// extracted by mini-css-extract-plugin
export default {"container":"style_container__3VV8h","insideTableContainer":"style_insideTableContainer__62i1+"};